import React, { useEffect } from 'react';

import { useAppSelector } from '../../../stores/redux.store';
import ReCAPTCHAEnterprise from '../../../components/ReCAPTCHAEnterprise';
import ReCaptchaContainer from '../../../components/ReCaptchaContainer';
import { useRecaptchaContext } from '../../../contexts/recaptcha';
import { useLoginTooManyAttemptsRecaptchaContext } from '../contexts/LoginTooManyAttemptsRecaptchaContext';
import { usePrevious } from '../../../utilities/hooks';
import { useRegisterComponent } from '../../orchestrator';

export const LoginRecaptcha = () => {
  useRegisterComponent(LoginRecaptcha.name);

  const { enabled: recaptchaEnabled, component: recaptchaComponent } = useRecaptchaContext();
  const isSecondStep = useAppSelector(state => state.login?.isUsernameChecked);
  const isCaptchaRequired = useAppSelector(state => state.login?.isCaptchaRequired);

  const shouldRenderCheckUsernameRecaptcha =
    !isSecondStep && recaptchaEnabled && recaptchaComponent;

  const { setCaptchaValue } = useLoginTooManyAttemptsRecaptchaContext();
  const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;

  const prevIsCaptchaRequired = usePrevious(isCaptchaRequired);

  useEffect(() => {
    if (prevIsCaptchaRequired && !isCaptchaRequired) {
      setCaptchaValue(null);
    }
  }, [isCaptchaRequired, prevIsCaptchaRequired, setCaptchaValue]);

  const isCaptchaEnabledByConfig = useAppSelector(state => state.appConfig?.recaptchaEnable);
  const recaptchaEnterpriseCheckboxKeySite = useAppSelector(
    state => state.appConfig?.recaptchaEnterpriseCheckboxKeySite
  );

  return (
    <>
      {isCaptchaEnabledByConfig &&
        (shouldRenderCheckUsernameRecaptcha ? (
          <ReCaptchaContainer>{recaptchaComponent}</ReCaptchaContainer>
        ) : (
          shouldRenderTooManyAttemptsRecaptcha && (
            <ReCaptchaContainer>
              <ReCAPTCHAEnterprise
                sitekey={recaptchaEnterpriseCheckboxKeySite}
                onChange={setCaptchaValue}
              />
            </ReCaptchaContainer>
          )
        ))}
    </>
  );
};
